import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, withRouter } from 'react-router';
import OptimizationPipelineLogEditService from '../service/OptimizationPipelineLogEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'optimizationPipelineLogEditForm',
		topic: 'optimizationPipelineLog',
		service: OptimizationPipelineLogEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'table_name',
					component: EditFormTextField
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				}
			];

			return fields;
		}
	};
};

function OptimizationPipelineLogEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });
	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(OptimizationPipelineLogEditForm);